import API from "./api";

export const uploadFile = async (
  file,
  tipo,
) => {
  const formData = new FormData();

  formData.append("file", file);
  formData.append("tipo", tipo);

  const res = await API.post(
    "/uploads",
    formData,
    {
      headers: {
        "Content-Type":
          "multipart/form-data",
      },
    },
  );

  return res.data;
};